module.exports = __webpack_public_path__ + "media/images/app-store-2539b325.png";